// src/components/common/ToggleSwitch.js
import React from "react";

export default function ToggleSwitch({
  icon,
  label,
  description,
  isEnabled,
  onToggle,
}) {
  return (
    <div className="flex items-center justify-between w-full p-3 bg-[#e1d4be] rounded-lg border border-[#c8bda9] shadow-inner">
      <div className="flex items-center">
        {icon && <span className="text-2xl mr-3">{icon}</span>}
        <div className="flex items-center">
          <div>
            <span className="font-semibold text-sm text-[#5a4a3a]">
              {label}
            </span>
            <p className="text-xs text-gray-600">{description}</p>
          </div>
        </div>
      </div>
      <button
        onClick={() => onToggle(!isEnabled)}
        className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors duration-200 ease-in-out focus:outline-none ${
          isEnabled ? "bg-[#556b2f]" : "bg-black/20"
        }`}
      >
        <span
          className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform duration-200 ease-in-out ${
            isEnabled ? "translate-x-6" : "translate-x-1"
          }`}
        />
      </button>
    </div>
  );
}
